import styled, { keyframes } from 'styled-components';
import { SectionParent } from '../../../components/StyledComponents';

import React from 'react';
import lottie, { AnimationItem } from 'lottie-web';

const Section = styled(SectionParent)`
  background-repeat: no-repeat;
  background-color: #f4f6fb;
  padding-top: 5rem !important;
  padding-bottom: 8rem !important;
  background-size: contain;
  @media (max-width: 1680px) and (min-width: 1440px) {
    padding: 0rem 20rem;
  }
  @media (max-width: 1440px) and (min-width: 1100px) {
    padding: 0rem 14rem;
  }

  @media (max-width: 800px) {
    padding: 0 5rem;
    padding-top: 3rem !important;
    padding-bottom: 2rem !important;
  }
  @media (max-width: 520px) {
    padding: 1.5rem;
    padding-top: 3rem !important;
    padding-bottom: 2rem !important;
  }
  width: 100%;
  display: grid;
`;

const Heading = styled.div`
  font-size: 36px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.61;
  letter-spacing: normal;
  color: #151828;
  text-align: center;
  padding-bottom: 1rem;
  @media (max-width: 520px) {
    font-size: 24px;
  }
`;

const SubHeading = styled.div`
  font-size: 18px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  text-align: center;
  padding: 0 10rem;
  padding-bottom: 2rem;
  color: #4f5263;
  @media (max-width: 768px) {
    text-align: center;
    padding: 0;
    padding-bottom: 2rem;
  }
  @media (max-width: 520px) {
    font-size: 14px;
  }
`;

const GridContainer = styled.div`
  border-radius: 4px;
  box-shadow: 0 8px 18px 0 rgba(72, 82, 108, 0.15);
  background-color: #ffffff;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  padding: 4rem 1rem;
  padding-right: 2rem;
  width: 100%;
  @media (max-width: 768px) {
    grid-template-columns: repeat(1, 1fr);
    padding-bottom: 2rem;
  }
  @media (max-width: 520px) {
    padding: 4rem 0rem;
    padding-right: 0rem;
  }
`;

export const placeholderKeyframe = keyframes`
    0% {
      background-position: -468px 0
    }
    100% {
      background-position: 468px 0
    }
  `;

const AnimationContainer = styled.div`
  grid-column: span 3;
  padding-bottom: 3rem;
  justify-self: center;
  width: 75%;
  @media (max-width: 768px) {
    grid-column: span 1;
    width: 100%;
  }
  .animation-container-item {
    height: 330px;
    opacity: 0.5;
    border-radius: 5px;
    animation-duration: 3s;
    animation-fill-mode: forwards;
    animation-iteration-count: infinite;
    animation-name: ${placeholderKeyframe};
    animation-timing-function: linear;
    background: #efefef;
    background-image: linear-gradient(
      to right,
      #e6e4e4 0%,
      #d8d8d8 20%,
      #eaeaea 40%,
      #e6e4e4 100%
    );
  }
`;

const GridBottom = styled.div`
  display: grid;
  grid-column: span 1;
  margin-left: 2rem;
  @media (max-width: 768px) {
    margin-left: 0rem;
    margin-bottom: 1rem;
    padding: 0 1rem;
  }
`;
const GridBottomTitle = styled.div`
  font-size: 21px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #52c9dc;
  text-align: left;
  padding-bottom: 1rem;
  @media (max-width: 768px) {
    text-align: center;
  }
`;

const GridBottomContent = styled.div`
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  color: #4f5263;
  text-align: left;
  min-height: 7rem;
  @media (max-width: 768px) {
    text-align: center;
  }
`;

export default class ProductSectionTwo extends React.Component<any, any> {
  animation?: AnimationItem;
  isCMounted = true;
  constructor(props: any) {
    super(props);
    this.animation = undefined;
    this.state = {
      animationLoading: true,
    };
  }

  componentDidMount() {
    this.isCMounted = true;
    setTimeout(async () => {
      this.setState({ animationLoading: false });
      const animationData =
        this.props?.messages?.locale !== 'en'
          ? await import('../../lottieAnimations/pipeline.de.json')
          : await import('../../lottieAnimations/pipeline.en.json');
      this.animation = lottie.loadAnimation({
        animationData,
        name: 'animation-pipeline',
        container: document.getElementById('pipeline-animation')!,
        loop: true,
        renderer: 'svg',
        autoplay: true,
      });
    }, 2000);
  }

  render() {
    return (
      <Section>
        <Heading>{this.props?.messages?.HomePageDevopsSectionTitle}</Heading>
        <SubHeading>
          {this.props?.messages?.HomePageDevopsSectionDescription}
        </SubHeading>
        <GridContainer>
          <AnimationContainer id="pipeline-animation">
            {this.state.animationLoading && (
              <div className="animation-container-item" />
            )}
          </AnimationContainer>
          <GridBottom>
            <GridBottomTitle>
              {this.props?.messages?.HomePageDevopsDevToolsTitle}
            </GridBottomTitle>
            <GridBottomContent>
              {this.props?.messages?.HomePageDevopsDevToolsDescription}
            </GridBottomContent>
          </GridBottom>
          <GridBottom>
            <GridBottomTitle>
              {this.props?.messages?.HomePageDevopsPipelineTitle}
            </GridBottomTitle>
            <GridBottomContent>
              {this.props?.messages?.HomePageDevopsPipelineDescription}
            </GridBottomContent>
          </GridBottom>
          <GridBottom>
            <GridBottomTitle>
              {this.props?.messages?.HomePageDevopsDeviceTelemetryTitle}
            </GridBottomTitle>
            <GridBottomContent>
              {this.props?.messages?.HomePageDevopsDeviceTelemetryDescription}
            </GridBottomContent>
          </GridBottom>
        </GridContainer>
      </Section>
    );
  }
}
